import { render, staticRenderFns } from "./ChurchView.vue?vue&type=template&id=18c45a2c"
import script from "./ChurchView.vue?vue&type=script&lang=js"
export * from "./ChurchView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports